import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import posthog from "posthog-js";
import { Container, Card, Image, Form } from "react-bootstrap";
import { Dimmer, Modal, Segment } from "semantic-ui-react";
import { Formik } from "formik";
import * as Yup from "yup";
import { isSubscriptionSuspended, fetchSubscriptionData } from "../../../../../utils/subscriptionUtils";
import SubscriptionRestriction from "../../../../common/subscriptionRestriction/SubscriptionRestriction";

import CompanyImage from "../../../../../resources/images/officeIcon.png";
import { Common } from "../../../../../utils";
import * as officeActions from "../officeActions";
import {
  getSelectedCompany,
  removeSpace,
  clearSelectedOffice,
  isEmpty,
} from "../../../../Global/CustomFunctions";
import { LocalStorage } from "../../../../Global";
import {
  DropDownList,
  CountryDropdown,
} from "../../../../common";
import FetchingSpinner from "../../../../common/FetchingSpinner";
import CommonPageHeader from "../../../../common/ui/page-header/CommonPageHeader";

import "./officeDashboard.scss";

class OfficeDashboard extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      Loading: false,
      selectedCompany: "",
      showAddWorkplaceModal: false,
      showEditWorkplaceModal: false,
      showDeleteConfirmModal: false,
      officeToDelete: null,
      isDeleting: false,
      deleteWorkplaceOption: "shiftUsers",
      deleteWorkplaceShiftToOfficeId: null,
    };
    this.redirect = this.redirect.bind(this);

    this.getEmployees = this.getEmployees.bind(this);
    this.handleEditOffice = this.handleEditOffice.bind(this);
    this.handleDeleteOffice = this.handleDeleteOffice.bind(this);
    this.confirmDeleteOffice = this.confirmDeleteOffice.bind(this);

    this.getAllOffices = this.getAllOffices.bind(this);
    this.redirectToCompDashboard = this.redirectToCompDashboard.bind(this);
  }
  redirectToCompDashboard() {
    this.props.history.push("/");
  }
  redirect() {
    let selectedCompany = getSelectedCompany();
    // if(selectedCompany=== undefined){
    //   selectedCompany = this.props.SelectedCompany;
    // }
    let link = `/${selectedCompany.name}/offices/create-office`;
    this.props.history.push(link);
  }

  componentDidMount() {
    this.props.officeActions.onGetCountries();
    this.props.officeActions.onGetBusinessDaysPresets();
    clearSelectedOffice();
    this.props.officeActions.removeOfficeSelected();
    let selectedCompany = getSelectedCompany();

    // Fetch offices immediately so loader shows and data appears without waiting for subscription.
    if (isEmpty(selectedCompany)) {
      this.props.history.push("/");
    } else {
      this.setState({ selectedCompany: selectedCompany.name });

      const { offices, officesCompanyId, officesLoading } = this.props.officeReducer;
      const hasDataForThisCompany =
        offices &&
        offices.length > 0 &&
        officesCompanyId === selectedCompany.id;

      if (!hasDataForThisCompany) {
        if (officesCompanyId != null && officesCompanyId !== selectedCompany.id) {
          this.props.officeActions.setOffices([], null);
        }
        if (!officesLoading) {
          this.getAllOffices(selectedCompany.id);
        }
      }
    }

    // Check subscription in background (do not block offices fetch or loader).
    fetchSubscriptionData()
      .then((subscriptionData) => {
        if (!subscriptionData || !subscriptionData.subscription || isSubscriptionSuspended(subscriptionData)) {
          this.setState({ isSubscriptionSuspended: true });
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("officeDashboardSubscription", {
            type: "exception",
            success: false,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
            status: error?.response?.status,
          });
        }
        this.setState({ isSubscriptionSuspended: true });
      });
  }

  getAllOffices = (id) => {
    this.props.officeActions
      .getAllOffices(id)
      .then((res) => {
        if (res.success) {
          this.props.officeActions.setOffices(res.data, id);
        } else {
          Common.showErrorMessage(res.message);
        }
      })
      .catch((error) => {
        Common.showErrorMessage(this.props.t("app.officeDashboard.errorSomethingWrong"));
        console.log(error);
      });
  };
  getEmployees(data) {
    const obj = { id: data.id, name: data.name, country: data.country };
    const officeJson = JSON.stringify(obj);
    // Save to both localStorage (persists across sessions) and sessionStorage (persists during session)
    localStorage.setItem(LocalStorage.selectedOffice, officeJson);
    sessionStorage.setItem("selectedOffice", officeJson);
    this.props.officeActions.setOfficeSelected();
    const office = removeSpace(data.name.toLowerCase());
    const cmp = removeSpace(this.state.selectedCompany.toLowerCase());
    const link = `/${cmp + "/" + office}/dashboard/time-off`;
    this.props.history.push(link);
  }

  handleEditOffice = (e, office) => {
    e.stopPropagation(); // Prevent card click event
    // Use the existing office data directly instead of making an API call
    this.props.officeActions.setOfficeForEdit(office);
    this.setState({ showEditWorkplaceModal: true });
  };

  handleDeleteOffice = (e, office) => {
    e.stopPropagation(); // Prevent card click event
    this.setState({
      showDeleteConfirmModal: true,
      officeToDelete: office,
      deleteWorkplaceOption: "shiftUsers",
      deleteWorkplaceShiftToOfficeId: null,
    });
  };

  confirmDeleteOffice = () => {
    const { officeToDelete, deleteWorkplaceOption, deleteWorkplaceShiftToOfficeId } = this.state;
    if (!officeToDelete) return;
    const officeId = officeToDelete.id || officeToDelete.Id;

    if (deleteWorkplaceOption === "shiftUsers" && !deleteWorkplaceShiftToOfficeId) {
      Common.showErrorMessage(this.props.t("app.officeDashboard.validationSelectWorkplaceRequired"));
      return;
    }

    const payload = {
      deleteOption: deleteWorkplaceOption,
      ...(deleteWorkplaceOption === "shiftUsers" && { shiftToOfficeId: deleteWorkplaceShiftToOfficeId }),
    };

    this.setState({ isDeleting: true });
    this.setState({
      showDeleteConfirmModal: false,
      officeToDelete: null,
      deleteWorkplaceOption: "shiftUsers",
      deleteWorkplaceShiftToOfficeId: null,
    });

    this.props.officeActions
      .onDeleteOffice(officeId, payload)
      .finally(() => {
        this.setState({ isDeleting: false });
      });
  };

  componentDidUpdate(prevProps) {
    // Load states when office for edit is loaded and has a country
    if (
      this.props.officeReducer.officeForEdit &&
      this.props.officeReducer.officeForEdit !==
      prevProps.officeReducer.officeForEdit
    ) {
      const countryId =
        this.props.officeReducer.officeForEdit.countryId ||
        this.props.officeReducer.officeForEdit.CountryId;
      if (countryId) {
        this.props.officeActions.onGetStatesByCountryId(countryId);
      }
    }
  }
  renderCompaniesList() {
    if (this.props.offices && this.props.offices.length > 0) {
      return this.props.offices.map((data) => {
        return (
          <div
            key={data.id}
            onClick={() => this.getEmployees(data)}
            className="border rounded m-1 office-card-container"
          >
            <div>
              <i
                className="bi bi-pencil-square"
                label="T"
                onClick={() => this.getEmployees(data)}
                style={{
                  fontSize: "1.5rem",
                  float: "left",
                  cursor: "pointer",
                  margin: "8px",
                }}
              ></i>
              <i
                className="bi bi-x"
                onClick={() => this.getEmployees(data)}
                style={{
                  fontSize: "2rem",
                  color: "red",
                  float: "right",
                  cursor: "pointer",
                  margin: "5px",
                }}
              ></i>
            </div>

            <div className="text-center py-5">
              <div className="cardLeft">
                <img
                  src={CompanyImage}
                  size="small"
                  alt=""
                  className="addCompanyImage"
                />
              </div>
              <div className="cardRight">
                <Card.Content>
                  <Card.Header>{data.name}</Card.Header>

                  <Card.Meta>{data.countryName}</Card.Meta>
                </Card.Content>
                <Card.Content extra></Card.Content>
              </div>
            </div>
          </div>
        );
      });
    } else {
      return (
        <div style={{ textAlign: "center", width: "100%" }}>
          No Office Added Yet!
        </div>
      );
    }
  }

  getBusinessDaysLabel(businessDaysValue) {
    const businessDaysPresets = this.props.officeReducer.businessDaysPresets;
    const preset = businessDaysPresets.find(
      (preset) => preset.value === businessDaysValue
    );
    return preset ? preset.text : "N/A";
  }

  getBusinessDaysOptions() {
    const businessDaysPresets = this.props.officeReducer.businessDaysPresets;

    // Use API data - ensure values are numbers
    return businessDaysPresets.map((preset) => ({
      key: preset.value,
      text: preset.label || preset.text, // Handle both label and text properties
      value: Number(preset.value), // Ensure value is a number
      description: preset.description,
    }));
  }

  render() {
    let roleId = this.props.roleId || this.props.UserRoleId;
    if (!roleId) {
      try {
        const { WebStorage, WebStorageNames } = require("../../../../../utils");
        roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
      } catch (e) {
        // fallback: try direct localStorage
        roleId = localStorage.getItem("roleId");
      }
    }
    const workplacesData = this.props.offices;
    const { officeReducer: officeStore } = this.props;

    // If subscription is suspended, show restriction message
    if (this.state.isSubscriptionSuspended) {
      return (
        <Container className="py-5 px-3 px-md-4" fluid>
          <div style={{ padding: "20px" }}>
            <SubscriptionRestriction actionKey="app.subscriptionRestriction.actionAccessDashboard" />
          </div>
        </Container>
      );
    }

    return (
      <Container className="py-4 px-3 px-md-4" fluid>
        <CommonPageHeader
          barClassName="office-header-bar"
          contentClassName="office-header-content"
          leftClassName="office-header-left"
          iconWrapperClassName="office-header-icon-wrapper"
          textClassName="office-header-text"
          titleClassName="office-page-title"
          descriptionClassName="office-page-description"
          rightClassName="office-header-right"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="white"
              viewBox="0 0 16 16"
              style={{ margin: 0 }}
            >
              <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
            </svg>
          }
          title={this.props.t("app.officeDashboard.title")}
          titleSuffix={
            workplacesData && workplacesData.length > 0 ? (
              <span
                className="badge rounded-pill"
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  fontSize: "12px",
                  fontWeight: "600",
                  padding: "5px 12px",
                  boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
                }}
              >
                {workplacesData.length}{" "}
                {workplacesData.length === 1
                  ? this.props.t("app.officeDashboard.workplace")
                  : this.props.t("app.officeDashboard.workplaces")}
              </span>
            ) : null
          }
          description={this.props.t("app.officeDashboard.description")}
          rightContent={
            roleId && parseInt(roleId) === 2 ? (
              <button
                type="button"
                className="btn d-flex align-items-center fw-semibold px-4 py-3 btn-brand"
                onClick={() => this.setState({ showAddWorkplaceModal: true })}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
                {this.props.t("app.officeDashboard.addNewWorkplace")}
              </button>
            ) : null
          }
        />

        {/* Workplace Cards Section - Using Leave Types Style */}
        <div style={{ position: 'relative', minHeight: '400px' }}>
          {officeStore.officesLoading && (
            <div className="office-dashboard-loader">
              <div className="office-dashboard-loader-content">
                <FetchingSpinner text={this.props.t("app.officeDashboard.loadingWorkplaces")} />
              </div>
            </div>
          )}
          <div className="row g-2">
            {workplacesData.map((workplace, index) => {
              const isPrimary =
                typeof workplace.isPrimary !== "undefined"
                  ? workplace.isPrimary
                  : index === 0;
              const isOnlyOne = workplacesData.length === 1;
              const workplaceColor = isPrimary ? "#10b981" : "#667eea";

              return (
                <div
                  key={index}
                  className="col-sm-12 col-md-6 col-lg-4 col-xl-4"
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                      border: `2px solid ${workplaceColor}20`,
                    }}
                    className="workplace-modern-card"
                    onClick={() => this.getEmployees(workplace)}
                  >
                    {/* Action Buttons - Top Right */}
                    <div className="workplace-card-actions" onClick={(e) => e.stopPropagation()}>
                      {/* Edit Button - Only show if roleId is 2 */}
                      {roleId && parseInt(roleId) === 2 && (
                        <button
                          className="workplace-action-btn workplace-edit-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleEditOffice(e, workplace);
                          }}
                          title={this.props.t("app.officeDashboard.editWorkplace")}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>
                      )}

                      {/* Delete Button - Only show if roleId is 2 and not primary */}
                      {roleId && parseInt(roleId) === 2 &&
                        !(isPrimary || isOnlyOne) && (
                          <button
                            className="workplace-action-btn workplace-delete-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.handleDeleteOffice(e, workplace);
                            }}
                            title={this.props.t("app.officeDashboard.deleteWorkplace")}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        )}
                    </div>

                    <div>
                      <div className="d-flex align-items-center mb-3">
                        {/* Color Indicator - Left Side */}
                        <div className="color-indicator-wrapper me-3">
                          <div
                            className="color-indicator"
                            style={{
                              backgroundColor: workplaceColor,
                            }}
                            title={this.props.t("app.officeDashboard.workplaceStatus")}
                          >
                            <i
                              className="bi bi-building"
                              style={{ color: "white", fontSize: "14px" }}
                            ></i>
                          </div>
                        </div>

                        {/* Workplace Name */}
                        <div className="workplace-name-section">
                          <div
                            className="workplace-name-text"
                            title={workplace.name}
                            style={{
                              color: workplaceColor,
                            }}
                          >
                            {workplace.name}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Workplace Details */}
                    <div className="workplace-details">
                      <div className="detail-row">
                        <div className="detail-label">
                          <i className="bi bi-geo-alt"></i>
                          {this.props.t("app.officeDashboard.location")}
                        </div>
                        <div className="detail-value">
                          {workplace.countryName}
                        </div>
                      </div>

                      <div className="detail-row">
                        <div className="detail-label">
                          <i className="bi bi-people-fill"></i>
                          {this.props.t("app.officeDashboard.employees")}
                        </div>
                        <div className="detail-value">
                          <span
                            style={{
                              fontWeight: '600',
                              color: workplaceColor,
                              fontSize: '15px'
                            }}
                          >
                            {workplace.userCount !== undefined && workplace.userCount !== null
                              ? workplace.userCount
                              : 0}

                          </span>
                        </div>
                      </div>

                      <div className="detail-row">
                        <div className="detail-label">
                          <i className="bi bi-calendar-week"></i>
                          {this.props.t("app.officeDashboard.businessDays")}
                        </div>
                        <div className="detail-value">
                          {this.getBusinessDaysLabel(
                            workplace.businessDaysValue
                          )}
                        </div>
                      </div>

                      <div className="detail-row">
                        <div className="detail-label">
                          <i className="bi bi-building"></i>
                          {this.props.t("app.officeDashboard.status")}
                        </div>
                        <div className="detail-value">
                          <span
                            className={`status-indicator ${isPrimary ? "active" : "inactive"
                              }`}
                          >
                            {isPrimary ? this.props.t("app.officeDashboard.primaryOffice") : this.props.t("app.officeDashboard.branchOffice")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Add New Workplace Card - Only show for admins */}
            {roleId && parseInt(roleId) === 2 && (
              <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                <div
                  className="workplace-modern-card workplace-add-card"
                  onClick={() => this.setState({ showAddWorkplaceModal: true })}
                >
                  <div className="workplace-add-card-content">
                    <div className="workplace-add-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                      </svg>
                    </div>
                    <div className="workplace-add-text">
                      <div className="workplace-add-title">{this.props.t("app.officeDashboard.addNewWorkplace")}</div>
                      <div className="workplace-add-subtitle">{this.props.t("app.officeDashboard.addNewWorkplaceCardSubtitle")}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <Modal
          open={this.state.showAddWorkplaceModal}
          onClose={() => this.setState({ showAddWorkplaceModal: false })}
          size="small"
          dimmer="blurring"
          centered
          style={{
            backgroundColor: 'transparent',
            backdropFilter: 'blur(2px)',
            height: "fit-content",
            margin: "auto",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
          }}
        >
          <Modal.Header className="modal-header-brand modal-header-brand-gradient">
            <div className="d-flex align-items-center">
              <div
                className="me-3"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
              </div>
              <div>
                <h4 className="mb-1 fw-bold">{this.props.t("app.officeDashboard.addNewWorkplace")}</h4>
                <p className="mb-0 opacity-75" style={{ color: "#e0f7fa" }}>
                  {this.props.t("app.officeDashboard.modalSubtitle")}
                </p>
              </div>
            </div>
          </Modal.Header>
          <Modal.Content style={{ padding: "24px" }}>
            <Formik
              enableReinitialize
              initialValues={{
                name: officeStore.name || "",
                countryId: officeStore.countryId || "",
                stateId: officeStore.stateId || "",
                address: officeStore.address || "",
                businessDaysValue: officeStore.businessDaysValue || 62,
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string()
                  .required(this.props.t("app.officeDashboard.validationNameRequired"))
                  .max(200, this.props.t("app.officeDashboard.validationNameMax")),
                countryId: Yup.number().required(this.props.t("app.officeDashboard.validationLocationRequired")),
                stateId: Yup.number()
                  .nullable()
                  .transform((value, originalValue) => {
                    return originalValue === "" ? null : value;
                  }),
                address: Yup.string()
                  .optional()
                  .max(1000, this.props.t("app.officeDashboard.validationAddressMax")),
                businessDaysValue: Yup.number().required(
                  this.props.t("app.officeDashboard.validationBusinessDaysRequired")
                ),
              })}
              onSubmit={async (values, { resetForm }) => {
                // Check if subscription is suspended
                if (this.state.isSubscriptionSuspended) {
                  let roleId = this.props.roleId || this.props.UserRoleId;
                  if (!roleId) {
                    try {
                      const { WebStorage, WebStorageNames } = require("../../../../../utils");
                      roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
                    } catch (e) {
                      roleId = localStorage.getItem("roleId");
                    }
                  }
                  const isAdmin = roleId && (parseInt(roleId) === 1 || parseInt(roleId) === 2);

                  if (isAdmin) {
                    Common.showErrorMessage(this.props.t("app.officeDashboard.errorSubscriptionSuspendedAdmin"));
                  } else {
                    Common.showErrorMessage(this.props.t("app.officeDashboard.errorSubscriptionSuspendedUser"));
                  }
                  return;
                }

                // Clean up values before submission - omit stateId if it's empty/null
                const cleanedValues = { ...values };

                // Remove stateId from payload if it's empty, null, or undefined
                if (cleanedValues.stateId === "" || cleanedValues.stateId === null || cleanedValues.stateId === undefined) {
                  delete cleanedValues.stateId;
                }

                await this.props.officeActions.isLoading(true);
                await this.props.officeActions.onAddOffice(
                  cleanedValues,
                  this.props.history
                );
                resetForm();
                this.setState({ showAddWorkplaceModal: false });
                this.getAllOffices(getSelectedCompany().id);
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
                setFieldValue,
                isSubmitting,
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    {this.state.isSubscriptionSuspended && (
                      <SubscriptionRestriction actionKey="app.subscriptionRestriction.actionAddNewWorkplaces" />
                    )}
                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-building me-2 text-primary"></i>
                            {this.props.t("app.officeDashboard.workplaceName")}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder={this.props.t("app.officeDashboard.workplaceNamePlaceholder")}
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.name && !!errors.name}
                            className="form-control-lg border-2"
                            style={{ borderRadius: "12px" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-geo-alt me-2 text-primary"></i>
                            {this.props.t("app.officeDashboard.country")}
                          </Form.Label>
                          <div>
                            <CountryDropdown
                              selection
                              search
                              value={values.countryId}
                              options={officeStore.countries}
                              placeholder={this.props.t("app.officeDashboard.selectCountry")}
                              className="w-100"
                              name="countryId"
                              onChange={(e, { value }) => {
                                setFieldValue("countryId", value);
                                // Clear state when country changes
                                setFieldValue("stateId", "");
                                if (value) {
                                  this.props.officeActions.onGetStatesByCountryId(
                                    value
                                  );
                                }
                              }}
                              loading={officeStore.isLoading}
                            />
                          </div>
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.countryId}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-map me-2 text-primary"></i>
                            {this.props.t("app.officeDashboard.stateProvince")}
                          </Form.Label>
                          <div>
                            <DropDownList
                              selection
                              value={values.stateId}
                              options={officeStore.states || []}
                              placeholder={this.props.t("app.officeDashboard.selectStateProvince")}
                              className="w-100"
                              name="stateId"
                              disabled={!values.countryId || values.countryId === ""}
                              onChange={(e, { value }) => {
                                setFieldValue("stateId", value);
                              }}
                              loading={officeStore.isLoading}
                            />
                          </div>
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.stateId}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-calendar-week me-2 text-primary"></i>
                            {this.props.t("app.officeDashboard.businessDays")}
                          </Form.Label>
                          <div>
                            <DropDownList
                              selection
                              value={values.businessDaysValue}
                              options={this.getBusinessDaysOptions()}
                              placeholder={this.props.t("app.officeDashboard.selectBusinessDays")}
                              className="w-100"
                              name="businessDaysValue"
                              onChange={(e, { value }) => {
                                setFieldValue("businessDaysValue", value);
                              }}
                              loading={officeStore.isLoading}
                            />
                          </div>
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.businessDaysValue}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-house me-2 text-primary"></i>
                            {this.props.t("app.officeDashboard.streetAddress")}
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="address"
                            placeholder={this.props.t("app.officeDashboard.streetAddressPlaceholderFull")}
                            value={values.address}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.address && !!errors.address}
                            className="border-2"
                            style={{ borderRadius: "12px", resize: "none" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.address}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-end gap-3 pt-3"
                      style={{ borderTop: "1px solid #e9ecef" }}
                    >
                      <button
                        className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                        type="button"
                        onClick={() =>
                          this.setState({ showAddWorkplaceModal: false })
                        }
                        style={{ borderRadius: "10px" }}
                      >
                        <i className="bi bi-x-circle me-2"></i>
                        {this.props.t("app.common.cancel")}
                      </button>
                      <button
                        className="btn btn-primary px-4 py-2 fw-semibold"
                        type="submit"
                        disabled={isSubmitting || officeStore.isLoading || this.state.isSubscriptionSuspended}
                        style={{
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                          position: "relative",
                        }}
                      >
                        {(isSubmitting || officeStore.isLoading) ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                borderWidth: "2px",
                              }}
                            ></span>
                            {this.props.t("app.officeDashboard.creatingWorkplace")}
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle me-2"></i>
                            {this.props.t("app.officeDashboard.createWorkplace")}
                          </>
                        )}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Modal.Content>
        </Modal>

        {/* Edit Workplace Modal */}
        <Modal
          open={this.state.showEditWorkplaceModal}
          onClose={() => this.setState({ showEditWorkplaceModal: false })}
          size="small"
          dimmer="blurring"
          centered
          style={{
            height: "fit-content",
            margin: "auto",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
          }}
        >
          <Modal.Header className="modal-header-brand modal-header-brand-gradient">
            <div className="d-flex align-items-center">
              <div
                className="me-3"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                </svg>
              </div>
              <div>
                <h4 className="mb-1 fw-bold">{this.props.t("app.officeDashboard.editWorkplace")}</h4>
                <p className="mb-0 opacity-75" style={{ color: "#e0f7fa" }}>
                  {this.props.t("app.officeDashboard.editWorkplaceSubtitle")}
                </p>
              </div>
            </div>
          </Modal.Header>
          <Modal.Content style={{ padding: "24px" }}>
            <Formik
              enableReinitialize
              initialValues={{
                id:
                  officeStore.officeForEdit?.id ||
                  officeStore.officeForEdit?.Id ||
                  "",
                name:
                  officeStore.officeForEdit?.name ||
                  officeStore.officeForEdit?.Name ||
                  "",
                countryId:
                  officeStore.officeForEdit?.countryId ||
                  officeStore.officeForEdit?.CountryId ||
                  "",
                stateId:
                  officeStore.officeForEdit?.stateId ||
                  officeStore.officeForEdit?.StateId ||
                  "",
                address:
                  officeStore.officeForEdit?.address ||
                  officeStore.officeForEdit?.Address ||
                  "",
                businessDaysValue:
                  officeStore.officeForEdit?.businessDaysValue || 62,
              }}
              key={
                officeStore.officeForEdit?.id ||
                officeStore.officeForEdit?.Id ||
                "new"
              } // Force re-render when office changes
              validationSchema={Yup.object().shape({
                name: Yup.string()
                  .required(this.props.t("app.officeDashboard.validationNameRequired"))
                  .max(200, this.props.t("app.officeDashboard.validationNameMax")),
                countryId: Yup.number().required(this.props.t("app.officeDashboard.validationLocationRequired")),
                stateId: Yup.number()
                  .nullable()
                  .transform((value, originalValue) => {
                    return originalValue === "" ? null : value;
                  }),
                address: Yup.string()
                  .optional()
                  .max(500, this.props.t("app.officeDashboard.validationAddressMax500")),
                businessDaysValue: Yup.number().required(
                  this.props.t("app.officeDashboard.validationBusinessDaysRequired")
                ),
              })}
              onSubmit={async (values, { resetForm }) => {
                // Clean up values before submission - omit stateId if it's empty/null
                const cleanedValues = { ...values };

                // Remove stateId from payload if it's empty, null, or undefined
                if (cleanedValues.stateId === "" || cleanedValues.stateId === null || cleanedValues.stateId === undefined) {
                  delete cleanedValues.stateId;
                }

                await this.props.officeActions.onEditOffice(
                  cleanedValues,
                  this.props.history
                );
                resetForm();
                this.setState({ showEditWorkplaceModal: false });
                this.props.officeActions.clearOfficeForEdit();
                this.getAllOffices(getSelectedCompany().id);
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
                setFieldValue,
                isSubmitting,
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-building me-2 text-success"></i>
                            {this.props.t("app.officeDashboard.workplaceName")}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder={this.props.t("app.officeDashboard.workplaceNamePlaceholder")}
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.name && !!errors.name}
                            className="form-control-lg border-2"
                            style={{ borderRadius: "12px" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-geo-alt me-2 text-success"></i>
                            {this.props.t("app.officeDashboard.country")}
                          </Form.Label>
                          <div>
                            <CountryDropdown
                              selection
                              search
                              value={values.countryId}
                              options={officeStore.countries}
                              placeholder={this.props.t("app.officeDashboard.selectCountry")}
                              className="w-100"
                              name="countryId"
                              onChange={(e, { value }) => {
                                setFieldValue("countryId", value);
                                this.props.officeActions.onGetStatesByCountryId(
                                  value
                                );
                              }}
                              loading={officeStore.isLoading}
                            />
                          </div>
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.countryId}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-map me-2 text-success"></i>
                            {this.props.t("app.officeDashboard.stateProvince")}
                          </Form.Label>
                          <div>
                            <DropDownList
                              selection
                              value={values.stateId}
                              options={officeStore.states}
                              placeholder={this.props.t("app.officeDashboard.selectStateProvince")}
                              className="w-100"
                              name="stateId"
                              onChange={(e, { value }) => {
                                setFieldValue("stateId", value);
                              }}
                              loading={officeStore.isLoading}
                            />
                          </div>
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.stateId}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-calendar-week me-2 text-success"></i>
                            {this.props.t("app.officeDashboard.businessDays")}
                          </Form.Label>
                          <div>
                            <DropDownList
                              selection
                              value={values.businessDaysValue}
                              options={this.getBusinessDaysOptions()}
                              placeholder={this.props.t("app.officeDashboard.selectBusinessDays")}
                              className="w-100"
                              name="businessDaysValue"
                              onChange={(e, { value }) => {
                                setFieldValue("businessDaysValue", value);
                              }}
                              loading={officeStore.isLoading}
                            />
                          </div>
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.businessDaysValue}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <Form.Group className="mb-4">
                          <Form.Label className="fw-semibold text-dark mb-2">
                            <i className="bi bi-house me-2 text-success"></i>
                            {this.props.t("app.officeDashboard.streetAddress")}
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="address"
                            placeholder={this.props.t("app.officeDashboard.streetAddressPlaceholderFull")}
                            value={values.address}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.address && !!errors.address}
                            className="border-2"
                            style={{ borderRadius: "12px", resize: "none" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            <i className="bi bi-exclamation-circle me-1"></i>
                            {errors.address}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-end gap-3 pt-3"
                      style={{ borderTop: "1px solid #e9ecef" }}
                    >
                      <button
                        className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                        type="button"
                        onClick={() => {
                          this.setState({ showEditWorkplaceModal: false });
                          this.props.officeActions.clearOfficeForEdit();
                        }}
                        style={{ borderRadius: "10px" }}
                      >
                        <i className="bi bi-x-circle me-2"></i>
                        {this.props.t("app.common.cancel")}
                      </button>
                      <button
                        className="btn btn-success px-4 py-2 fw-semibold"
                        type="submit"
                        disabled={isSubmitting || officeStore.isLoading}
                        style={{
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                          border: "none",
                          position: "relative",
                        }}
                      >
                        {(isSubmitting || officeStore.isLoading) ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                borderWidth: "2px",
                              }}
                            ></span>
                            {this.props.t("app.officeDashboard.updatingWorkplace")}
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle me-2"></i>
                            {this.props.t("app.officeDashboard.updateWorkplace")}
                          </>
                        )}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Modal.Content>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal
          open={this.state.showDeleteConfirmModal}
          onClose={() =>
            this.setState({
              showDeleteConfirmModal: false,
              officeToDelete: null,
              deleteWorkplaceOption: "shiftUsers",
              deleteWorkplaceShiftToOfficeId: null,
            })
          }
          size="tiny"
          dimmer="blurring"
          centered
          className="delete-confirm-modal"
          style={{
            height: "fit-content",
            margin: "auto",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
            overflow: "visible",
          }}
        >
          <Modal.Header
            className="delete-modal-header"
            style={{

              zIndex: 1,
              display: "block",
              visibility: "visible",
              opacity: 1,
              width: "100%",
            }}
          >
            <div className="d-flex align-items-center">
              <div
                className="me-3"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
              </div>
              <div>
                <h4 className="mb-1 fw-bold">{this.props.t("app.officeDashboard.deleteWorkplace")}</h4>
                <p className="mb-0 opacity-75">{this.props.t("app.officeDashboard.deleteWorkplaceCannotUndo")}</p>
              </div>
            </div>
          </Modal.Header>
          <Modal.Content style={{ padding: "24px" }}>
            <div className="text-center">
              <div className="mb-4">
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                  }}
                >
                  <svg width="40" height="40" fill="white" viewBox="0 0 16 16">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fillRule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4.5 4.5H15v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4.118z"
                    />
                  </svg>
                </div>
              </div>

              <h5 className="fw-bold text-dark mb-3">
                {this.props.t("app.officeDashboard.deleteWorkplaceConfirm")}
              </h5>

              <p className="text-muted mb-4">
                {this.props.t("app.officeDashboard.deleteWorkplaceDetail", {
                  name: this.state.officeToDelete?.name || this.state.officeToDelete?.Name || "",
                })}
              </p>

              <div className="text-start mb-4">
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="deleteWorkplaceOption"
                    id="deleteWorkplaceOptionShift"
                    checked={this.state.deleteWorkplaceOption === "shiftUsers"}
                    onChange={() => this.setState({ deleteWorkplaceOption: "shiftUsers", deleteWorkplaceShiftToOfficeId: null })}
                  />
                  <label className="form-check-label" htmlFor="deleteWorkplaceOptionShift">
                    {this.props.t("app.officeDashboard.deleteWorkplaceOptionShiftUsers")}
                  </label>
                </div>
                {this.state.deleteWorkplaceOption === "shiftUsers" && (
                  <div className="ms-4 mb-3 delete-workplace-select-wrapper">
                    <Form.Control
                      as="select"
                      value={String(this.state.deleteWorkplaceShiftToOfficeId ?? "")}
                      onChange={(e) => this.setState({ deleteWorkplaceShiftToOfficeId: e.target.value ? Number(e.target.value) : null })}
                      className="delete-workplace-select form-select"
                    >
                      <option value="">
                        {this.props.t("app.officeDashboard.deleteWorkplaceSelectWorkplacePlaceholder")}
                      </option>
                      {(this.props.offices || [])
                        .filter((o) => (o.id || o.Id) !== (this.state.officeToDelete?.id || this.state.officeToDelete?.Id))
                        .map((o) => {
                          const id = o.id ?? o.Id;
                          return (
                            <option key={id} value={id}>
                              {o.name || o.Name || ""}
                            </option>
                          );
                        })}
                    </Form.Control>
                  </div>
                )}
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="deleteWorkplaceOption"
                    id="deleteWorkplaceOptionDeleteUsers"
                    checked={this.state.deleteWorkplaceOption === "deleteUsers"}
                    onChange={() => this.setState({ deleteWorkplaceOption: "deleteUsers", deleteWorkplaceShiftToOfficeId: null })}
                  />
                  <label className="form-check-label" htmlFor="deleteWorkplaceOptionDeleteUsers">
                    {this.props.t("app.officeDashboard.deleteWorkplaceOptionDeleteUsers")}
                  </label>
                </div>
              </div>

              <div className="d-flex justify-content-center gap-3">
                <button
                  className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                  type="button"
                  onClick={() =>
                    this.setState({
                      showDeleteConfirmModal: false,
                      officeToDelete: null,
                      deleteWorkplaceOption: "shiftUsers",
                      deleteWorkplaceShiftToOfficeId: null,
                    })
                  }
                  style={{ borderRadius: "10px" }}
                >
                  <i className="bi bi-x-circle me-2"></i>
                  {this.props.t("app.common.cancel")}
                </button>
                <button
                  className="btn btn-danger px-4 py-2 fw-semibold"
                  type="button"
                  onClick={this.confirmDeleteOffice}
                  disabled={
                    this.state.isDeleting ||
                    (this.state.deleteWorkplaceOption === "shiftUsers" && !this.state.deleteWorkplaceShiftToOfficeId)
                  }
                  style={{
                    borderRadius: "10px",
                    background:
                      this.state.isDeleting ||
                        (this.state.deleteWorkplaceOption === "shiftUsers" && !this.state.deleteWorkplaceShiftToOfficeId)
                        ? "#9ca3af"
                        : "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                    border: "none",
                    opacity: this.state.isDeleting ? 0.8 : 1,
                  }}
                >
                  {this.state.isDeleting ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      {this.props.t("app.officeDashboard.deletingWorkplace")}
                    </>
                  ) : (
                    <>
                      <i className="bi bi-trash me-2"></i>
                      {this.props.t("app.officeDashboard.deleteWorkplace")}
                    </>
                  )}
                </button>
              </div>
            </div>
          </Modal.Content>
        </Modal>

      </Container>
    );
  }
}
const mapStateToProps = ({ officeReducer, companyReducer, accountReducer }) => {
  const { offices, loading } = officeReducer;
  const { companyId, selectedCompany } = companyReducer;
  return {
    offices,
    loading,
    companyId,
    selectedCompany,
    officeReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    officeActions: bindActionCreators(officeActions, dispatch),
    dispatch: dispatch,
  };
};
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OfficeDashboard));
